export const goToAttacmentURL = (url: string) => {
  window.open(url, '_blank')?.focus();
};
